import isFunction from 'is-function';
import { MiddlewareArgs } from './types';
// v0.0.2

export function MethodProxy<T extends object>(
	fs: T,
	middleware: (args: MiddlewareArgs) => void
) {
	return new Proxy(fs, {
		get(target: T, propKey: string | number | symbol, receiver: any) {
			const targetValue = Reflect.get(target, propKey, receiver);

			if (!isFunction(targetValue)) {
				return targetValue;
			}

			return (...args: any[]) => {
				//@ts-ignore
				const methodResult = fs[propKey](...args);

				const result = middleware({ targetResult: methodResult, propKey: propKey });

				return result;
			};
		},
	});
}
